















































import { Component, Vue, Prop } from 'vue-property-decorator'

import { OptionItemType } from './type'
type InputListType = 'checkbox' | 'radio'

@Component({})
export default class InputList extends Vue {
  @Prop({ required: true, default: '' }) private id!: string
  @Prop({ required: false, default: [] }) private options!: OptionItemType[]
  @Prop({ required: false, default: 'checkbox' }) private type!: InputListType
  @Prop({ required: true, default: false }) private hasError!: boolean
  @Prop({ required: true, default: null }) private value!:
    | string
    | string[]
    | null

  private get localValues() {
    if (!Array.isArray(this.value)) return []
    return this.value || []
  }

  private get localValue() {
    if (Array.isArray(this.value)) return ''
    return this.value || ''
  }

  private set localValue(v: string) {
    this.$emit('input', v)
  }

  private onToggle(value: string, checked: boolean) {
    if (checked) {
      this.$emit('input', [...this.localValues, value])
    } else {
      const filter = this.localValues.filter(v => v !== value)
      this.$emit('input', filter || [])
    }
  }
}
